// extracted by mini-css-extract-plugin
var _1 = "MultiFactorAuthStyle-module__description___uU8XJ";
var _2 = "MultiFactorAuthStyle-module__description--recovery___OJrYk";
var _3 = "MultiFactorAuthStyle-module__description--recovery___OJrYk";
var _4 = "MultiFactorAuthStyle-module__hide-two___G05KU";
var _5 = "MultiFactorAuthStyle-module__hide-two___G05KU";
var _6 = "MultiFactorAuthStyle-module__multi-factor-auth___fGHS4";
var _7 = "MultiFactorAuthStyle-module__multi-input___OBTCR";
var _8 = "MultiFactorAuthStyle-module__multi-factor-auth___fGHS4";
var _9 = "MultiFactorAuthStyle-module__multi-input___OBTCR";
var _a = "MultiFactorAuthStyle-module__toggle-code-type___ILHRP";
var _b = "MultiFactorAuthStyle-module__toggle-code-type___ILHRP";
var _c = "MultiFactorAuthStyle-module__validate-button___pgsjt";
var _d = "MultiFactorAuthStyle-module__validate-button___pgsjt";
export { _1 as "description", _2 as "description--recovery", _3 as "descriptionRecovery", _4 as "hide-two", _5 as "hideTwo", _6 as "multi-factor-auth", _7 as "multi-input", _8 as "multiFactorAuth", _9 as "multiInput", _a as "toggle-code-type", _b as "toggleCodeType", _c as "validate-button", _d as "validateButton" }
